import React,{useEffect,useState} from "react";
import {productionDayCount,today} from "./bannerModel";

export default function ProductionCounter({appointmentId,appointment}) {
  const [date,setDate]=useState(today);
  useEffect(()=>{const timer=setInterval(()=>setDate(today()),60000);return ()=>clearInterval(timer);},[]);
  const count=appointment ? productionDayCount(appointment.appointmentDate,date) : null;
  return <section className="banner-production-counter" aria-label="Days in production"><details><summary>Days in production <strong className="banner-production-days">{count ? count.days : "\u2014"}</strong>{count ? (count.days===1 ? " day" : " days") : ""}</summary>
    {!appointmentId ? <p>Link a photo appointment to start the counter.</p> : !appointment ? <p>The linked photo appointment is unavailable.</p> : !count ? <p>The linked appointment has no valid shoot date.</p> : <>
      <p>Photo day: {count.shootDate}</p>
      {count.startsIn>0 ? <p>Starts in {count.startsIn} {count.startsIn===1 ? "day" : "days"}.</p> : <p className="banner-muted">Calendar days since photo day, including weekends. Photo day is day 0.</p>}
    </>}
  </details></section>;
}
